import { Typography, styled } from "@material-ui/core";

export const InputFieldDescriptionText = styled(Typography)({
  color: "#AEAFC7",
  fontFamily: "'Inter', 'sans-serif'",
  fontSize: "12px",
  fontWeight: 400,
  // Dark mode (additive): only applies under the `.dark` root; light unchanged.
  "html.dark &": {
    color: "hsl(var(--sds-muted-foreground))",
  },
});
